<template>
  <transition @enter="enter" @leave="leave">
    <div
      v-if="game.gameEnded"
      class="game-result"
      :data-color="game.partialScore > 2 ? 'green' : 'orange'"
    >
      <span>{{ game.partialScore }}/4</span>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import anime from '@/assets/libs/anime';

export default {
  name: 'GameResult',

  computed: {
    ...mapState({
      game: 'currentGame',
    }),
  },

  methods: {
    enter(el, done) {
      anime({
        targets: el,
        scale: [0, 1],
        rotate: [25, 0],
        duration: 1200,
        delay: 3600,
        easing: 'cubicBezier(.5,0,0,1)',
        complete: done,
      });
    },
    leave(el, done) {
      anime({
        targets: el,
        scale: 0,
        rotate: [0, -15],
        duration: 1200,
        easing: 'cubicBezier(.5,0,0,1)',
        complete: done,
      });
    },
    resize() {},
  },
};
</script>

<style lang="scss" scoped>
.game-result {
  position: fixed;
  top: calc(var(--unit-vw) * 2);
  right: calc(var(--unit-vw) * 0.3);
  width: calc(162px * var(--rw));
  height: calc(162px * var(--rw));

  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;

  display: flex;
  align-items: center;
  justify-content: center;

  @include mq($until: ipadP) {
    top: calc(var(--unit-vh) * 7);
    right: 50%;
    width: calc(100px * var(--rw));
    height: calc(100px * var(--rw));
    margin-right: calc(-50px * var(--rw));

    z-index: 0;

    &[data-hidden] {
      z-index: -1;
    }
  }

  &[data-color="green"] {
    background-image: url('/img/svg/happy-background.svg');
  }

  &[data-color="orange"] {
    background-image: url('/img/svg/sad-background.svg');
  }

  & span {
    @extend %font-size-question;
    color: $color-white;

    transform: rotate(-10deg);
  }
}
</style>
